<template>
  <quill
    ref="editor"
    output="html"
    @input="onEditorChange($event)"
    :config="{
      ...config,
      placeholder
    }"
    :content="value"
  />
</template>

<script>
import Quill from 'vue-quill/src/Quill'
export default {
  components: {
    Quill
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    config() {
      return {
        theme: 'bubble',
        placeholder: this.placeholder
      }
    }
  },
  methods: {
    onEditorChange(content) {
      this.$emit('input', content)
    }
  }
}
</script>
